export const ACCESS_TKN_KEY = 'accessToken'
export const APP_NAME = 'appName'
export const BUSINESS_ENTITY = 'businessEntityId'
export const GRAPH_TOKEN = 'graphToken'
export const REFRESH_TOKEN = 'refreshToken'
export const USER_DATA = 'userData'
export const USER_NAME = 'UserName'
export const ROLES = 'roles'
export const GUEST_POPUP = 'guestPopUpShown'

export class StorageService {
    static clear() {
        localStorage.clear()
        sessionStorage.clear()
    }

    static setItem(key: string, value: any) {
        localStorage.setItem(key, value)
    }

    static getItem(key: string) {
        return localStorage.getItem(key)
    }

    static removeItem(key: string) {
        localStorage.removeItem(key)
    }
}
